import { makeStyles, Typography } from "@material-ui/core";
import React from "react";
import { useIntl } from "react-intl";
import CardItem from "../../components/CardItem";

const useStyles = makeStyles(theme => ({
  root: {
    display: "flex",
    overflowX: "auto",
    "& > *": {
      minWidth: theme.spacing(20),
      width: theme.spacing(20),
      marginRight: theme.spacing(1)
    }
  }
}));

const RecordingList = ({ recordings = [], onRecordingClick }) => {
  const intl = useIntl();
  const classes = useStyles();

  if (recordings.length === 0) {
    return (
      <Typography variant="body2">
        {intl.formatMessage({
          id: "Sessions.RecordingList.NoRecordings",
          defaultMessage: "The recordings will be available soon."
        })}
      </Typography>
    );
  }
  return (
    <div className={classes.root}>
      {recordings.map(({ id, videoUrl, title, description }) => (
        <CardItem
          videoUrl={videoUrl}
          title={title}
          description={description}
          onClick={
            onRecordingClick && (() => onRecordingClick({ id, videoUrl, title, description }))
          }
          showFallback
        />
      ))}
    </div>
  );
};

export default RecordingList;
